import customAxios from "../../customAxios";

import { TRANSFER_DRIVERS_ACADEMIC_YEAR } from "../../routes";
import { ITransferDriversToAcademicYear } from "../../../types/driver.interface";

/**
 * Carries the given drivers into an academic year, so drivers who only worked last year show up in this year's
 * list without waiting for their new service contracts.
 */
async function transferDriversToAcademicYear(props: ITransferDriversToAcademicYear): Promise<any> {
  try {
    return (await customAxios.post(TRANSFER_DRIVERS_ACADEMIC_YEAR, props)).data;
  } catch (error: any) {
    console.error({ TRANSFER_DRIVERS_ACADEMIC_YEAR: error });
  }
}

export default transferDriversToAcademicYear;
